export default __webpack_public_path__ + "static/media/archi_view3_g.a48ed110.webp";